import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { useNavigate } from '@lib/react-router-dom'

import { useAccountReadContext } from '@context/AccountContextContext'
import { useProductReadContext } from '@context/ProductContext'

import {
  getApptestRiskScreenProduct,
  isEconomicProfileTestNeeded,
} from '@utils/AccountAccess/accountProductStatuses'
import {
  getProductAppTestRiskAcceptancePath,
  getProductAppropriatenessTestRiskPath,
  isFirstDepositPath,
  useBasePath,
} from '@utils/path'

export const ProductRedirect: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { account } = useAccountReadContext()
  const { product } = useProductReadContext()
  const { redirectionLink } = useBasePath()
  const redirectionParam = new URLSearchParams(location.search).get('redir')
  const isPostLoginRedirect = location.pathname.includes('/login')
  const shouldPrioritizeFirstDeposit = isFirstDepositPath(redirectionLink)
  const appTestRiskProduct = isPostLoginRedirect
    ? getApptestRiskScreenProduct(account, product)
    : undefined
  const appTestRiskPath =
    appTestRiskProduct && isEconomicProfileTestNeeded(account, appTestRiskProduct)
      ? getProductAppTestRiskAcceptancePath(appTestRiskProduct)
      : appTestRiskProduct
      ? getProductAppropriatenessTestRiskPath(appTestRiskProduct)
      : undefined

  useEffect(() => {
    if (redirectionParam && location.pathname.includes('/login/2fa')) {
      navigate(`/login${location.search}`, { replace: true })
      return
    }

    if (appTestRiskPath && !shouldPrioritizeFirstDeposit) {
      navigate(appTestRiskPath, { replace: true })
      return
    }

    navigate(redirectionLink, { replace: true })
  }, [
    appTestRiskPath,
    location.pathname,
    location.search,
    navigate,
    redirectionLink,
    redirectionParam,
    shouldPrioritizeFirstDeposit,
  ])

  return null
}
